export default __webpack_public_path__ + "static/media/undraw_Online_learning_re_qw08.f93ad190.svg";